import { Order } from "src/shared/services/interface";

export const buildReturnPayload = (order: Order, returnQty: Record<number, number>, totals: any, refundType: string, reverseDiscount: number) => {
  return {
    returnProduct: order.Products.map((p, i) => ({
      productId: p.productId,
      productName: p.productName,
      returnQty: returnQty[i] || 0,
      totalPrice: (returnQty[i] || 0) * p.amount,
      amount: p.amount,
      uom: p.uom,
      arabicword: p.arabicword,
    })).filter((p) => p.returnQty > 0),

    orderStatus: "Return and Refund",
    refOrderId: order.Orderid,

    Refund: {
      refundType,
      subTotal: totals.amount,
      refundAmount: totals.refund, // ✅ USE CALCULATED REFUND
      adjustedAmount: totals.adjusted, // ✅ ADD THIS
      discount: reverseDiscount,
    },
  };
};
